import { useLocation } from 'react-router-dom';

export const useQueryParam = (param: string) => {
   const { search } = useLocation();
   const query = new URLSearchParams(search);
   const value = query.get(param) || undefined;
   return { [param]: value };
};
